import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListOW, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import CustomerIndex from "../../pagesSub/msCustomer/CustomerIndex";
import BarangKategoriIndex from "../../pagesSub/msBarangKategori/BarangKategoriIndex";
import BarangFormCekIndex from "../../pagesSub/msBarangFormCek/BarangFormCekIndex";

import StockCategorySubIndex from "../../pagesSub/msStockCategorySub/StockCategorySubIndex";
import StockCategoryIndex from "../../pagesSub/msStockCategory/StockCategoryIndex";
import StockItemIndex from "../../pagesSub/msStockItem/StockItemIndex";
import StokItemRusakIndex from "../../pagesSub/msStockItemRusak/StokItemRusakIndex";

import DiscountMasterIndex from "../../pagesSub/msDiscount/DiscountMasterIndex";
import DiscountSpecialIndex from "../../pagesSub/msDiscountSpecial/DiscountSpecialIndex";
import DiscountReviewIndex from "../../pagesSub/msDiscountReview/DiscountReviewIndex";

import SupplierIndex from "../../pagesSub/msSupplier/SupplierIndex";
import CustomerGroupIndex from "../../pagesSub/msCustomerGroup/CustomerGroupIndex";

const MasterOW = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListOW.master.slug;
    const roleUser = role.owner;
    const slugLink = roleUser.subLevel.owner.slugLink;

    // info : struktur menuList nya harus sama !
    const menuListUserForDirectNotaStep = menuListOW;

    return (
        <LayoutAppShell
            stateMenuList={menuListOW}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListOW.master.subMenu.two.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <CustomerIndex
                        stateMenuList={menuListUserForDirectNotaStep}
                    />
                </React.Fragment>
            }

            {menuListOW.master.subMenu.customerGroup.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <CustomerGroupIndex
                        stateMenuList={menuListUserForDirectNotaStep}
                    />
                </React.Fragment>
            }

            {menuListOW.master.subMenu.brgKtgr.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangKategoriIndex />
                </React.Fragment>
            }

            {menuListOW.master.subMenu.formCekBrg.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangFormCekIndex />
                </React.Fragment>
            }

            {menuListOW.master.subMenu.stock.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListOW.master.subMenu.stock.tabs.two.flag}>
                                {menuListOW.master.subMenu.stock.tabs.two.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.master.subMenu.stock.tabs.three.flag}>
                                {menuListOW.master.subMenu.stock.tabs.three.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.master.subMenu.stock.tabs.one.flag}>
                                {menuListOW.master.subMenu.stock.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.master.subMenu.stock.tabs.four.flag}>
                                {menuListOW.master.subMenu.stock.tabs.four.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListOW.master.subMenu.stock.tabs.one.flag}>
                            <StockItemIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.master.subMenu.stock.tabs.two.flag}>
                            <StockCategoryIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.master.subMenu.stock.tabs.three.flag}>
                            <StockCategorySubIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.master.subMenu.stock.tabs.four.flag}>
                            <StokItemRusakIndex />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }

            {menuListOW.master.subMenu.supplier.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <SupplierIndex />
                </React.Fragment>
            }

            {menuListOW.master.subMenu.discount.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListOW.master.subMenu.discount.tabs.one.flag}>
                                {menuListOW.master.subMenu.discount.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.master.subMenu.discount.tabs.two.flag}>
                                {menuListOW.master.subMenu.discount.tabs.two.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListOW.master.subMenu.discount.tabs.three.flag}>
                                {menuListOW.master.subMenu.discount.tabs.three.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListOW.master.subMenu.discount.tabs.one.flag}>
                            <DiscountMasterIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.master.subMenu.discount.tabs.two.flag}>
                            <DiscountSpecialIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListOW.master.subMenu.discount.tabs.three.flag}>
                            <DiscountReviewIndex />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default MasterOW;